import { useEffect, useState } from 'react';
import { PinKeypad, PIN_DIGIT_COUNT } from './PinKeypad';

// Verify-PIN flow. Caller passes the expected PIN; we shake on mismatch and
// call onSuccess on a clean entry.
export function PinEnterPrompt({
  expected,
  onSuccess,
  title = 'Syötä PIN',
}: {
  expected: string;
  onSuccess: () => void;
  title?: string;
}) {
  const [pin, setPin] = useState('');
  const [shake, setShake] = useState(false);

  useEffect(() => {
    if (pin.length !== PIN_DIGIT_COUNT) return;
    if (pin === expected) {
      onSuccess();
      return;
    }
    setShake(true);
    const t = setTimeout(() => {
      setPin('');
      setShake(false);
    }, 450);
    return () => clearTimeout(t);
  }, [pin, expected, onSuccess]);

  return (
    <div className="pin-modal" role="dialog" aria-label={title}>
      <h2 className="pin-title">🔐 {title}</h2>
      <PinKeypad value={pin} onChange={setPin} shake={shake} />
    </div>
  );
}
